import axios from 'axios';

const getPdf = async (car, time, distance, downpayment, monthlyFee, carImg) => {
    // console.log('sim params', {car, time: time.value, distance: distance.value, downpayment, monthlyFee, carImg})
    const response = await axios.post('/api/kinto/service_simulation_pdf/', {
        car,
        time: time.value,
        distance: distance.value,
        downpayment: downpayment,
        fee: monthlyFee,
        img: carImg
    }, {
        headers: {
            'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
        },
        responseType: 'blob'  // CRITICAL: Le dice a axios que espere datos binarios
    });

    return response;
}


export { getPdf };